<template>
  <div class="details extra-content">
    <b-row class="p-0">
      <b-col cols="12 p-0" v-if="edroDetails && edroDetails.length > 0">
        <div class="pt-15 br-2" v-for="(edro, index) in edroDetails.filter(edroDetail => edroDetail.identifier === selectedEdro.id)" :key="index">
          <div class="pb-15">
            <b-row>
              <b-col cols="3" class="p-0">
                {{ edro.title }}
              </b-col>
              <b-col cols="4" v-if="edro.scheduler && edro.scheduler.milestones && edro.scheduler.milestones.length > 0">
                Milestones:
                <span v-for="(milestones, index) in edro.scheduler.milestones" :key="index">
                  {{ milestones }}
                  <span v-if="index + 1 < edro.scheduler.milestones.length">,</span>
                </span>
              </b-col>
            </b-row>
          </div>
          <div class="p-0">
            <div class="pb-10" v-if="edro.category">
              <div class="content">
                Category
              </div>
              <div class="header">
                {{ edro.category }}
              </div>
            </div>
            <div class="pb-10" v-if="edro.description">
              <div class="content">
                Instruction Details
              </div>
              <div class="header">
                {{ edro.description }}
              </div>
            </div>
            <div class="pb-10" v-if="edro.configurationSettings">
              <div class="content">
                Default configuration settings
              </div>
              <div class="header" v-for="(setting, index) in edro.configurationSettings" :key="index">{{ setting.name }}: {{ setting.details }}</div>
            </div>
            <div class="pb-10" v-if="edro.dataCollected">
              <div class="content">
                Data collected
              </div>
              <div class="header pl-10" v-for="(data, index) in edro.dataCollected" :key="index">
                <li>{{ data }}</li>
              </div>
            </div>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.milestones">
              <b-col class="p-0">
                <div class="content">
                  To be completed at milestones
                </div>
                <div class="header">
                  <span v-for="(milestone, index) in edro.scheduler.milestones" :key="index">
                    {{ milestone }}
                    <span v-if="index + 1 < edro.scheduler.milestones.length">,</span>
                  </span>
                </div>
              </b-col>
              <b-col v-if="edro.scheduler.completionWindow" class="p-0">
                <div class="content">
                  Completion window
                </div>
                <div class="header">{{ edro.scheduler.completionWindow }} days</div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.frequency">
              <b-col class="p-0">
                <div class="content">
                  Frequency
                </div>
                <div class="header">
                  {{ edro.scheduler.frequency.title }}
                </div>
              </b-col>
              <b-col v-if="edro.scheduler.completionWindow" class="p-0">
                <div class="content">
                  Completion window
                </div>
                <div class="header">{{ edro.scheduler.completionWindow }} days</div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.isActivityOptional">
              <b-col class="p-0">
                <div class="content">
                  Activity is optional and will be excluded from the compliance report.
                </div>
                <div class="header">
                  Yes
                </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.allowMultipleTimes">
              <b-col class="p-0">
                <div class="content">
                  Allow participants to repeat activity each time it is present
                </div>
                <div class="header">
                  Yes
                </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.duration">
              <b-col class="p-0" cols="4" v-for="(item, index) in edro.scheduler.duration" :key="index">
                <b-col cols="12" class="content p-0" v-if="index === 0 && (item.startDay || item.endDay)">
                  Scheduled as follows
                </b-col>
                <b-row class="p-0">
                  <b-col class="p-0" cols="3" v-if="item.startDay">
                    <div class="content">
                      Start Day
                    </div>
                    <div class="header">
                      {{ item.startDay }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="3" v-if="item.endDay">
                    <div class="content">
                      End Day
                    </div>
                    <div class="header">
                      {{ item.endDay }}
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && !(edro.scheduler.milestones && edro.scheduler.milestones.length > 0)">
              <b-col class="p-0" v-if="edro.scheduler.allowUntillDuration">
                <div class="content">
                  Available until the end of participant's study duration
                </div>
                <div class="header">
                  Yes
                </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.reminders && edro.scheduler.reminders.length">
              <b-col cols="12" class="content p-0">
                Reminders
              </b-col>
              <b-col class="p-0" cols="12">
                <b-row class="p-0">
                  <b-col class="p-0" cols="2">
                    <div class="content">
                      Day
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="6">
                    <div class="content">
                      Message
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="content">
                      Time
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="content">
                      Notification type
                    </div>
                  </b-col>
                </b-row>
                <b-row class="p-0" v-for="(item, index) in edro.scheduler.reminders" :key="index">
                  <b-col class="p-0" cols="2">
                    <div class="header">
                      {{ item.day }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="6">
                    <div class="header" v-if="item.message">
                      {{ item.message }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="header" v-if="item.time">
                      {{ item.time }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="header">
                      <span>Mobile</span>
                      <span v-if="item.emailToggle">, Email</span>
                      <span v-if="item.smsToggle">, SMS Text</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* 
IMPORTANT
Please make sure that this file and edros.vue which is inside the study-details folder are in sync so that the PDF is updated with the most recent code.
 */
export default {
  name: "edro-details",
  data() {
    return {
      edroDetails: [],
      selectedEdro: {},
      studyId: this.$route.params.studyId
      // edroId: this.$route.params.edroId,
    };
  },
  props: {
    edroId: {
      type: String
    },
    edroLists: {
      type: Array
    }
  },
  methods: {
    async getEdroDetails() {
      try {
        this.edroDetails = this.edroLists;
      } catch (error) {
        this.$toastr.error(error.message || "Unable to fetch the instructions and notifications.");
      }
    }
  },
  mounted() {
    this.getEdroDetails();
    this.selectedEdro.id = this.edroId;
  }
};
</script>

<style scoped>
/* .details {
  background-color: #fff;
  width: 100%;
  height: 100%;
  position: absolute;
} */
.inner-card {
  border: none;
  margin: 5px 20px;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.content {
  font-size: 12px;
  color: #666669;
}
.header {
  font-size: 12px;
  font-weight: bold;
  color: #666669;
}

.card {
  padding: 15px;
  margin-bottom: 16px;
}
</style>
